import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_SUCCESS,
  EMAIL_SIGN_IN,
  EMAIL_SIGN_UP,
  GOOGLE_SIGN_IN,
  REFRESH_TOKEN_FAILURE,
  REFRESH_TOKEN_SUCCESS,
  RESTORE_AUTH_FAILURE,
  RESTORE_AUTH_FROM_STORAGE,
  RESTORE_AUTH_SUCCESS,
  SET_AUTH_ERROR,
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_OUT,
  SIGN_OUT_FAILURE,
  SIGN_OUT_SUCCESS,
  SIGN_UP_FAILURE,
  VERIFY_TOKEN_FAILURE,
} from './authentication/authentication.action.type';
import { authenticationReducers } from './authentication/authentication.reducer';
import { CLEAR_ERROR } from './error/error.action.type';
import { errorReducers } from './error/error.reducer';
import {
  RETRIEVE_FIGHTERS,
  RETRIEVE_FIGHTERS_FAILURE,
  RETRIEVE_FIGHTERS_SUCCESS,
} from './fighter/fighter.action.type';
import { fighterReducers } from './fighter/fighter.reducer';
import { CLOSE_SIDEBAR, OPEN_SIDEBAR } from './sidebar/sidebar.action.type';
import { sidebarReducers } from './sidebar/sidebar.reducer';
import {
  CREATE_USER_PROFILE,
  CREATE_USER_PROFILE_FAILURE,
  CREATE_USER_PROFILE_SUCCESS,
  DELETE_USER_PROFILE,
  DELETE_USER_PROFILE_FAILURE,
  DELETE_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE,
  GET_USER_PROFILE_FAILURE,
  GET_USER_PROFILE_SUCCESS,
  SET_USER_ERROR,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_FAILURE,
  UPDATE_USER_PROFILE_SUCCESS,
} from './user/user.action.type';
import { userReducers } from './user/user.reducer';

import {
  RETRIEVE_FIGHTS,
  RETRIEVE_FIGHTS_FAILURE,
  RETRIEVE_FIGHTS_SUCCESS,
} from './fight/fight.action.type';
import { fightReducers } from './fight/fight.reducer';
import {
  RETRIEVE_FIGHTER_IMAGE,
  RETRIEVE_FIGHTER_IMAGE_FAILURE,
  RETRIEVE_FIGHTER_IMAGE_SUCCESS,
} from './image/image.action.type';
import { imageReducer } from './image/image.reducer';
import {
  RETRIEVE_SEASONS,
  RETRIEVE_SEASONS_FAILURE,
  RETRIEVE_SEASONS_SUCCESS,
} from './season/season.action.type';
import { seasonReducer } from './season/season.reducer';
import {
  RETRIEVE_SEASON_FIGHTS,
  RETRIEVE_SEASON_FIGHTS_FAILURE,
  RETRIEVE_SEASON_FIGHTS_SUCCESS,
} from './seasonFights/seasonFights.action.type';
import { seasonFightsReducers } from './seasonFights/seasonFights.reducer';
import {
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS,
  RETRIEVE_TOURNAMENTS,
  RETRIEVE_TOURNAMENTS_BY_USER,
  RETRIEVE_TOURNAMENTS_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_FAILURE,
  RETRIEVE_TOURNAMENTS_SUCCESS,
  RETRIEVE_TOURNAMENT_DETAILS,
  RETRIEVE_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_TOURNAMENT_DETAILS_SUCCESS,
} from './tournament/tournament.action.type';
import { tournamentReducer } from './tournament/tournament.reducer';
import {
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS,
  RETRIEVE_USER_SEASON,
  RETRIEVE_USER_SEASON_FAILURE,
  RETRIEVE_USER_SEASON_SUCCESS,
  UPSERT_USER_SEASON,
  UPSERT_USER_SEASON_FAILURE,
  UPSERT_USER_SEASON_SUCCESS,
} from './userSeason/userSeason.action.type';
import { userSeasonReducer } from './userSeason/userSeason.reducer';

export const appReducers = {
  // fighters
  [RETRIEVE_FIGHTERS]: fighterReducers,
  [RETRIEVE_FIGHTERS_SUCCESS]: fighterReducers,
  [RETRIEVE_FIGHTERS_FAILURE]: fighterReducers,

  // fights
  [RETRIEVE_FIGHTS]: fightReducers,
  [RETRIEVE_FIGHTS_SUCCESS]: fightReducers,
  [RETRIEVE_FIGHTS_FAILURE]: fightReducers,

  // sidebar
  [OPEN_SIDEBAR]: sidebarReducers,
  [CLOSE_SIDEBAR]: sidebarReducers,

  // authentication
  [SIGN_IN_SUCCESS]: authenticationReducers,
  [SIGN_IN_FAILURE]: authenticationReducers,
  [SIGN_UP_FAILURE]: authenticationReducers,
  [SIGN_OUT]: authenticationReducers,
  [SIGN_OUT_SUCCESS]: authenticationReducers,
  [SIGN_OUT_FAILURE]: authenticationReducers,
  [EMAIL_SIGN_UP]: authenticationReducers,
  [GOOGLE_SIGN_IN]: authenticationReducers,
  [EMAIL_SIGN_IN]: authenticationReducers,
  [VERIFY_TOKEN_FAILURE]: authenticationReducers,
  [REFRESH_TOKEN_SUCCESS]: authenticationReducers,
  [REFRESH_TOKEN_FAILURE]: authenticationReducers,
  [RESTORE_AUTH_FROM_STORAGE]: authenticationReducers,
  [RESTORE_AUTH_SUCCESS]: authenticationReducers,
  [RESTORE_AUTH_FAILURE]: authenticationReducers,
  [SET_AUTH_ERROR]: authenticationReducers,
  [CHANGE_PASSWORD]: authenticationReducers,
  [CHANGE_PASSWORD_SUCCESS]: authenticationReducers,
  [CHANGE_PASSWORD_FAILURE]: authenticationReducers,

  // user
  [GET_USER_PROFILE]: userReducers,
  [GET_USER_PROFILE_SUCCESS]: userReducers,
  [GET_USER_PROFILE_FAILURE]: userReducers,
  [CREATE_USER_PROFILE]: userReducers,
  [CREATE_USER_PROFILE_SUCCESS]: userReducers,
  [CREATE_USER_PROFILE_FAILURE]: userReducers,
  [UPDATE_USER_PROFILE]: userReducers,
  [UPDATE_USER_PROFILE_SUCCESS]: userReducers,
  [UPDATE_USER_PROFILE_FAILURE]: userReducers,
  [SET_USER_ERROR]: userReducers,
  [DELETE_USER_PROFILE]: userReducers,
  [DELETE_USER_PROFILE_SUCCESS]: userReducers,
  [DELETE_USER_PROFILE_FAILURE]: userReducers,

  // season fights
  [RETRIEVE_SEASON_FIGHTS]: seasonFightsReducers,
  [RETRIEVE_SEASON_FIGHTS_SUCCESS]: seasonFightsReducers,
  [RETRIEVE_SEASON_FIGHTS_FAILURE]: seasonFightsReducers,

  // seasons
  [RETRIEVE_SEASONS]: seasonReducer,
  [RETRIEVE_SEASONS_SUCCESS]: seasonReducer,
  [RETRIEVE_SEASONS_FAILURE]: seasonReducer,

  // user season
  [RETRIEVE_USER_SEASON]: userSeasonReducer,
  [RETRIEVE_USER_SEASON_SUCCESS]: userSeasonReducer,
  [RETRIEVE_USER_SEASON_FAILURE]: userSeasonReducer,
  [UPSERT_USER_SEASON]: userSeasonReducer,
  [UPSERT_USER_SEASON_SUCCESS]: userSeasonReducer,
  [UPSERT_USER_SEASON_FAILURE]: userSeasonReducer,
  [RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON]: userSeasonReducer,
  [RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS]: userSeasonReducer,
  [RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE]: userSeasonReducer,
  [RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON]: userSeasonReducer,
  [RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS]: userSeasonReducer,
  [RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE]: userSeasonReducer,

  // tournaments
  [RETRIEVE_TOURNAMENTS]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_SUCCESS]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_FAILURE]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_BY_USER]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_BY_USER_FAILURE]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_CREATED_BY_USER]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS]: tournamentReducer,
  [RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE]: tournamentReducer,
  [RETRIEVE_TOURNAMENT_DETAILS]: tournamentReducer,
  [RETRIEVE_TOURNAMENT_DETAILS_SUCCESS]: tournamentReducer,
  [RETRIEVE_TOURNAMENT_DETAILS_FAILURE]: tournamentReducer,
  [RETRIEVE_GLOBAL_TOURNAMENT_DETAILS]: tournamentReducer,
  [RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS]: tournamentReducer,
  [RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE]: tournamentReducer,

  //error
  [CLEAR_ERROR]: errorReducers,

  // image
  [RETRIEVE_FIGHTER_IMAGE]: imageReducer,
  [RETRIEVE_FIGHTER_IMAGE_SUCCESS]: imageReducer,
  [RETRIEVE_FIGHTER_IMAGE_FAILURE]: imageReducer,
};
